import { useQuery } from '@tanstack/react-query';
import { getTaskResultProperty } from '../pages/P&T/workflow';

interface UseTaskResultPropertyOptions {
  enabled?: boolean;
  retry?: boolean | number;
  refetchOnWindowFocus?: boolean;
}

/**
 * Custom hook to fetch task result property for a given xevmpdId
 * @param xevmpdId - The xEVMPD ID to fetch task properties for
 * @param userID - The user ID making the request
 * @param options - Query options (enabled, retry, refetchOnWindowFocus)
 * @returns Query result with taskButtonConfig data
 */
export const useTaskResultProperty = (
  xevmpdId: string | undefined,
  userID: string | undefined,
  options?: UseTaskResultPropertyOptions
) => {
  return useQuery(
    ["fetchTaskResultProperty", xevmpdId],
    () => getTaskResultProperty(xevmpdId!, userID!),
    {
      enabled: !!xevmpdId && !!userID && (options?.enabled !== false),
      retry: options?.retry ?? false,
      refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
      select(response) {
        console.log("getTaskResultProperty response:", response);
        if (response?.data && (response.data as any).code === 200) {
          console.log("getTaskResultProperty response data:", (response.data as any).data);
          return (response.data as any).data;
        }
        return (response.data as any)?.data || null;
      },
    }
  );
};
